module.exports = __webpack_public_path__ + "img/fira-code-light.b4d7d444.png";